import OServicesModalOtg3 from './o-services-modal-otg-3.vue';

export default OServicesModalOtg3;